import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";

const DummySubmitVivaDialog = ({
  open,
  onClose,
  onConfirm,
  questions = [],
  questionStatus = {},
  forceSubmit = false,
  isSubmitting = false,
}) => {
  const totalQuestions = questions.length;

  const mandatoryQuestions = questions.filter(
    (q) => q.IsMandatory === 1 || q.IsMandatory === "1"
  );
  const totalMandatory = mandatoryQuestions.length;

  const answeredMandatory = mandatoryQuestions.filter(
    (q) => questionStatus[q.Id] === "answered"
  ).length;

  const notAnsweredMandatory = totalMandatory - answeredMandatory;

  const totalAnswered = Object.values(questionStatus).filter(
    (status) => status === "answered"
  ).length;

  const allMandatoryAnswered = notAnsweredMandatory === 0;

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (forceSubmit || isSubmitting) return;
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        onClose();
      }}
      disableEscapeKeyDown={forceSubmit || isSubmitting}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        sx={{
          fontWeight: 700,
          fontSize: "1.5rem",
          textAlign: "center",
          pb: 1,
        }}
      >
        Submit Viva Exam
      </DialogTitle>

      <DialogContent dividers>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 3, textAlign: "center" }}
        >
          Are you sure you want to submit? This action cannot be undone.
        </Typography>

        <Box
          sx={{
            bgcolor: "grey.50",
            borderRadius: 2,
            p: 3,
            border: "1px solid",
            borderColor: "divider",
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{ color: "primary.main", mb: 2 }}
          >
            Exam Summary
          </Typography>

          <SummaryRow label="Total Questions" value={totalQuestions} />
          <SummaryRow
            label="Attempted"
            value={totalAnswered}
            valueColor="success.main"
          />
          <SummaryRow
            label="Total Mandatory"
            value={
              <>
                {totalMandatory} <span style={{ color: "red" }}>★</span>
              </>
            }
          />
          <SummaryRow
            label="Mandatory Answered"
            value={`${answeredMandatory} / ${totalMandatory}`}
            valueColor={
              allMandatoryAnswered ? "success.main" : "warning.main"
            }
          />
        </Box>

        {notAnsweredMandatory > 0 && (
          <Box
            sx={{
              mt: 3,
              p: 2,
              bgcolor: "error.50",
              border: "1px solid",
              borderColor: "error.light",
              borderRadius: 2,
              textAlign: "center",
            }}
          >
            <Typography color="error.main" fontWeight={600}>
              Warning: {notAnsweredMandatory} mandatory question
              {notAnsweredMandatory > 1 ? "s" : ""} not answered!
            </Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions
        sx={{
          p: 3,
          justifyContent: forceSubmit ? "center" : "space-between",
          gap: 2,
        }}
      >
        {!forceSubmit && (
          <Button
            onClick={onClose}
            variant="outlined"
            color="inherit"
            disabled={isSubmitting}
            size="large"
          >
            Cancel
          </Button>
        )}

        <Button
        className="finalsubmit"
          onClick={onConfirm}
          variant="contained"
          color="primary"
          size="large"
          disabled={isSubmitting}
          sx={{
            minWidth: 160,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          {isSubmitting ? (
            <>
              <CircularProgress size={20} color="inherit" />
              Submitting...
            </>
          ) : (
            "Submit Final"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// Helper component for consistent summary rows
const SummaryRow = ({ label, value, valueColor = "text.primary" }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      py: 1,
      borderBottom: "1px solid",
      borderColor: "divider",
      "&:last-child": { borderBottom: "none" },
    }}
  >
    <Typography variant="body1">{label}</Typography>
    <Typography
      variant="body1"
      fontWeight={600}
      sx={{ color: valueColor }}
    >
      {value}
    </Typography>
  </Box>
);

export default DummySubmitVivaDialog;